import { FC } from "react";
import Section from "components/corphurusato/parts/Section";
import Headline, { Big } from "components/corphurusato/parts/Headline";
import SubHeadline from "components/corphurusato/parts/SubHeadline";
import Paragraph from "components/corphurusato/parts/Paragraph";
import styled from "styled-components";
import Content from "components/corphurusato/parts/Content";

const AboutCorpHurusato: FC = () => {
  return (
    <Section>
      <Headline color={"#2685EB"}>
        <Big>企業版</Big>ふるさと納税とは
      </Headline>
      <Content>
        <Paragraph>企業が「応援したい自治体に寄附することで税金の9割控除」が受けられる制度です。</Paragraph>
        <Paragraph>寄附されたお金は「自治体の対象プロジェクト」に活用されます。</Paragraph>
        <Annotation>※本社所在地の自治体には寄附できません。</Annotation>
        <Annotation>※個人版と異なり、返礼品を受け取ることはできません。</Annotation>
        <ImageArea>
          <Picture>
            <source srcSet="/image/lp/corphurusato/about/figure_01_pc.png" media="(min-width: 960px)" />
            <img src="/image/lp/corphurusato/about/figure_01_sp.png" alt="企業版ふるさと納税とは" />
          </Picture>
        </ImageArea>
        <SubHeadline label="企業のメリット" color={"#2685EB"} />
        <ImageArea>
          <Image src="/image/lp/corphurusato/about/figure_02.png" alt="企業のメリット" />
        </ImageArea>
      </Content>
    </Section>
  );
};

export default AboutCorpHurusato;

const Picture = styled.picture`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;

  & > source,
  & > img {
    width: 100%;
  }
`;

const ImageArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 960px) {
    margin: 20px auto;
  }

  @media screen and (min-width: 961px) {
    margin: 30px auto;
  }
`;

const Image = styled.img`
  width: 100%;
  max-width: 600px;
`;

const Annotation = styled(Paragraph)`
  @media screen and (max-width: 960px) {
    font-size: 0.75em;
  }
`;
